import {
    Button,
    Container,
    Grid,
    Paper,
    TextField,
    Typography,
    Box,
    ThemeProvider,
    Stack,
    Chip,
    Radio,
    RadioGroup,
    FormControlLabel,

   
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import RatingLabel from "../Components/RatingLabel";
  import { useForm } from "react-hook-form";
  import { useNavigate, useSearchParams } from "react-router-dom";
  import { addResponseAssessmentByStId, getAllStaff, getAssessmentByStId,
     getInternshipRequestById, updateStudentSupervisor, getAssessmentCoopByStId, addResponseAssessmentCoopByStId
   } from "../api/crud";
  import { useDispatch } from "react-redux";
  import { updateSnackbar } from "../redux/action/dataAction";
  import { createTheme} from '@mui/material/styles';
  import { matchOptions } from "./../utils/function";
  import { optionsBranch } from "./../data/branch-data";
  import { useSelector } from "react-redux";
 

  import '@fontsource/prompt';
  import { CircularProgress } from "@mui/material";
  import useMediaQuery from "@mui/material/useMediaQuery";
  import { is } from "date-fns/locale";
  
  
  
  
  const theme = createTheme({
    typography: {
      fontFamily: 'Prompt, sans-serif',
      fontWeightBold: 600,
      fontWeightLight: 300,
    },
  });
  
  const AssessmentVisitCoop = () => {
    const isMobile = useMediaQuery('(max-width:767px)');
    const dispatch = useDispatch();
    const hookForm = useForm();
    const navigate = useNavigate();
    const { handleSubmit, register, reset,setValue, watch } = hookForm;
    const [searchParams] = useSearchParams();
    const req_id = searchParams.get("req_id");
  
    const [studentData, setStudentData] = useState({});
    const [studentId, setStudentId] = useState("");
    const [studentName, setStudentName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [companyID, setCompanyID] = useState("");
    const [b_id, set_b_id] = useState("");
    const [viewonly, setViewonly] = useState(false);
    const [supervisor, setSupervisor] = useState("");
    const [score, setScore] = useState(0);
    const list25Value = watch('list_25');
    const list26Value = watch('list_26');
  
  
    const profile = useSelector((state) => state.profileReducer.profile);
  
    useEffect(() => {
      if (
        !profile ||
        (profile.m_role !== "staff" && profile.id !== req_id?.slice(0, 8))
      ) {
        navigate("/");
      }else if(profile.m_role !== "staff" && profile.id === req_id?.slice(0, 8)){
        setViewonly(true);
            //getAssessmentByStId(req_id);
      }
  
    }, [profile]);
  
  
    const lists = [
      { label: "มีความรับผิดชอบต่องานที่ได้รับมอบหมาย" },
      { label: "ปฏิบัติงานด้วยความกระตือรือร้น" },
      { label: "มีการปรับปรุงคุณภาพงานที่ปฏิบัติอยู่เสมอ" },
      { label: "ใช้เวลาในการทำงานให้เกิดประโยชน์สูงสุด" },
      { label: "มีการรายงานผลการปฏิบัติงาน" },
    
    ];

    const lists2 = [
        { label: "ปฏิบัติงานโดยใช้ความรู้ ความสามารถที่มีอยู่อย่างเต็มที่" },
        { label: "มีความสามารถในการประยุกต์ใช้ความรู้" },
        { label: "มีความชำนาญในด้านปฏิบัติการ" },
        { label: "มีความสามารถในการวางแผน จัดลำดับความสำคัญของงาน" },
        { label: "ใฝ้รู้ สนใจศึกษาหาความรู้ใหม่ ๆ เพิ่มเติม" },
      ];

      const lists3 = [
          { label: "ปฏิบัติตามกฎ ระเบียบหรือข้อบังคับขององค์กรโครงเคร่งครัด" },
          { label: "เข้างานตรงเวลา ไม่เคยขาด ไม่เคยสาย" },
          { label: "ให้ความเคารพเชื่อฟังผู้บังคับบัญชา" },
          { label: "มีความขยัน อดทน สู้งาน" },
          { label: "มีคุณธรรม จริยธรรม เช่น ซื่อสัตย์ สุจริต รักษาความลับองค์กร" },
          { label: "มีความคิดริเริ่ม สร้างสรรค์" },
          { label: "มีความมั่นใจในตนเอง กล้าสอบถาม และเสนอความคิดเห็น" },
          { label: "มีบุคลิกภาพและวางตัวเหมาะสม เช่น การแต่งกาย กิริยาวาจา วุฒิภาวะ" },
          { label: "มีความสามารถในการทำงานเป็นทีมร่วมกับผู้อื่น" },

      ];

      const lists4 = [
            { label: "ความเหมาะสมของหัวข้อโครงงาน" },
            { label: "แผนปฏิบัติงาน" },
            { label: "ความก้าวหน้าของการจัดทำรายงาน ( Work term Report)" },
            { label: "รายละเอียดของเนื้อหารายงาน" },
            { label: "สรุปคุณภาพโดยรวมของนิสิต" },

      ];
  
    
  
  
    const getDataById = () => {
  
      getAssessmentCoopByStId(req_id)
        .then((res) => {
              
          setStudentData(res);
          res && setViewonly(true);
          const score = parseInt(res?.list_1) + parseInt(res?.list_2) + parseInt(res?.list_3) + parseInt(res?.list_4) + parseInt(res?.list_5) + parseInt(res?.list_6) + parseInt(res?.list_7) + parseInt(res?.list_8) + parseInt(res?.list_9) + parseInt(res?.list_10) + parseInt(res?.list_11) + parseInt(res?.list_12)
          + parseInt(res?.list_13) + parseInt(res?.list_14) + parseInt(res?.list_15) + parseInt(res?.list_16) + parseInt(res?.list_17) + parseInt(res?.list_18) + parseInt(res?.list_19) + parseInt(res?.list_20) + parseInt(res?.list_21) + parseInt(res?.list_22) + parseInt(res?.list_23) + parseInt(res?.list_24);
          setScore(score);
          //setValue('list_25', parseInt(res?.list25));


          
  
          reset(res);
        })
        .catch((err) => {
          console.log(err);
        });
        
        getInternshipRequestById(req_id)
        .then((resArr) => {
          const res = resArr[0];
          // console.log("dataStudent", res);
  
          if (res) {
            setStudentId(res.st_id);
            setStudentName(res.st_name);
            set_b_id(res.b_id);
            setCompanyName(res.cp_name);
            setCompanyID(res.cp_id);
            supervisorNameOptions(res?.supervisor)
            studentData?.evaluatorName == null
            && setValue("evaluatorName", supervisor);
  
            setValue("company.name_th", res.cp_name);
            
          }
        })
        .catch((err) => {
          console.log(err);
        });
  
  
    };
  
    useEffect(() => {
      if (req_id) {
        getDataById();
       
      } else {
        navigate("/");
      }
    }, [req_id, supervisor, setViewonly]);

    useEffect(() => {
        if (studentData?.list_25) {
          setValue('list_25', parseInt(studentData.list_25));
        }

        if (studentData?.list_26) {
            setValue('list_26', parseInt(studentData.list_26));
          }

      }, [studentData, setValue]);
  
    const supervisorNameOptions = async (value) => {
      const response = await getAllStaff();
      //console.log("supervisor", response);
      setSupervisor(response.find((item) => item.id === value).name);
      
    };
  
  
    const onSubmit = async (formValue) => {
      try {
        const response = await addResponseAssessmentCoopByStId(req_id, formValue, studentData == null ? 0 : 1);
  
        console.log("assessment", response);
  
        dispatch(
          updateSnackbar({
            open: true,
            content: "บันทึกการประเมินเรียบร้อยแล้ว",
          })
        );
      } catch (error) {
        console.warn(error);
  
        dispatch(
          updateSnackbar({
            open: true,
            content: "มีข้อผิดพลาด",
          })
        );
      }
    };
  
    return (
      <ThemeProvider theme={theme}>
      {!studentId ? ( 
        // ถ้าเป็น moblie ไม่ต้องใช้ Container และ Box แล้ว
  
        <Container>
        
     
          <Box 
            flexDirection={"column"} 
            display={"flex"} 
            justifyContent={"center"}
            alignItems={"center"}
            padding={4}
            sx={{ width: "100%" }}
          >
            <CircularProgress />
            Loading...
  
            
          
       
          </Box>
        </Container>) 
      
      : (
  
      <Container maxWidth="md">
        <Paper elevation={isMobile ? 0 : 5} sx={{
         p: isMobile ? 1 : 5, mt:3
        }}>
   
          <Box mb={3} textAlign="Start">
                  <Grid sm={2} md={2}
                  >
                    <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold', color: '#86191f' }}>
                      <img src={'./assets/images/logo_no_bg.png'} alt="BUU|ENG" width="25%" />
                    </Typography>
                  </Grid>
           <Grid sm={4} md = {10}>
  
            <Stack  alignItems="Start" justifyContent="Left"
             >
            <Typography variant={isMobile ? "h6" : "h4"} color="primary" sx ={{fontWeight: 'bold'
            }}>
             แบบประเมินผลการปฏิบัติงานนิสิตสหกิจศึกษา
            </Typography>
          
            <Typography variant={isMobile ? "subtitle1" : "h6"} color="textSecondary" sx={
              { fontWeight: 'bold'}
            }>
             คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา
            </Typography>
            </Stack>
            </Grid>
          </Box>
          
          
            
                
              <Box mb={2} textAlign="Start" bgcolor="#f3f1f2" borderRadius={2} p={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} >
              <Chip color="primary" label={`RequestID: ${req_id || ''}`} />
              </Grid>
              {/* <Grid item xs={12} md={8} textAlign={"start"}>
              
                    <Typography sx={{ fontSize: 16, fontWeight:
                    'bold', fontSize: '1.2em'
                    }}>ขัอมูลนิสิตฝึกงาน </Typography>
                  </Grid> */}
              <Grid item xs={12} md={3} textAlign={
                "center"
              }>
                {studentId !== null  ? (
                  <img
                    src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${studentId}`}
                    width="120px"
                  />
                ) : (
                  <img src={`./assets/images/user.png`} width="120px" />
                )}
                 
              </Grid>
             
                <Grid item xs={12} md={9}>
                  
                  <Grid item xs={6} >
                    <Typography>{"ข้อมูลนิสิตฝึกงาน"}</Typography>
                  </Grid>
                  <Grid item xs={4} >
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{studentId}</Typography>
                  </Grid>
  
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{studentName} </Typography>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{matchOptions(optionsBranch, b_id)}</Typography>
                  </Grid>
                    
                  <Grid item xs={12} md={8}>
                    <Typography sx={{ fontSize: 16 }}>สถานประกอบการที่ฝึกงาน: </Typography>
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{companyName}</Typography>
                  </Grid>
                  
         
  
                    {/* <Grid item xs={12}>
                      <TextField
                        label="ฝ่าย/แผนกที่ฝึกงาน"
                        {...register("department")}
                      />
                    </Grid> */}
                  <Grid item xs={4}>
                  <Typography >อาจารย์นิเทศ:</Typography>
                  </Grid>
                  <Grid item xs={12}>
                  <Typography sx={{ fontSize: 16, fontWeight: 'bold', fontSize: '1.2em'}}>{supervisor}</Typography>
                  </Grid>
              
                  </Grid>
  
                  
                  <Grid item xs={12}>
                    <Box p={1} border={1} bgcolor="#fcc98a" borderColor="grey.300" borderRadius={2} textAlign="center" alignItems={"center"}>
                      <Typography sx={{ fontWeight: "bold" }}>คะแนนรวม: (เต็ม 120)</Typography>
                      
                      {studentData == null ? (
                        <Typography>ยังไม่มีการประเมิน</Typography>
  
                      ) : (
                              <div>
                                 
                                <Typography>ผลการประเมิน {score} คะแนน</Typography>
                                {profile.m_role === "staff" && (
                                <Button variant="contained" color="primary" onClick={() => {
                                        viewonly ? setViewonly(false) : setViewonly(true);
                                      } }>
                                        {viewonly ? 'แก้ไขคะแนน' : 'ยกเลิก'}
                                      </Button>
                                )}
                              </div>
                            )}  
                          </Box>
                        </Grid>
              
  
                  </Grid>
                  </Box>
  
           
         
  
          <form onSubmit={handleSubmit(onSubmit)}>
  
          <Box mb={3} p={2} border={1} bgcolor="#E3F2FD" borderColor="grey.300" borderRadius={1}>
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <Typography variant="h5" color="primary" fontWeight={'bold'}
                                            sx={{ textDecoration: 'underline' }}>
                                            ส่วนที่ 1
                                        </Typography>
                                        {!isMobile ? (
                                            <Typography variant="h6" color="black">
                                                ประเมินผลการปฏิบัติงานของนิสิตสหกิจศึกษา
                                            </Typography>
                                        ) : (
                                            <Typography variant="h6" color="black">
                                                ประเมินผลการปฏิบัติงาน
                                            </Typography>
                                        )}
                                    </Box>

                                    <Container>
                                    <Box
                                        sx={{
                                            background: '#1976D2',
                                            borderRadius: 1,
                                            boxShadow: 'none',
                                            color: 'white', 
                                            px: 2, // Keep horizontal padding
                                            py: 0, // Remove vertical padding
                                            //mb: 1,
                                            mt: 3,
                                            position: 'relative',
                                            display: 'inline-block',
                                            minWidth: 'fit-content',
                                            height: 'fit-content', // Ensure height fits content exactly
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '50%', // Center the accent bar
                                                transform: 'translateY(-50%)', // Center the accent bar
                                                width: '4px',
                                                height: '100%',
                                                backgroundColor: '#FFCC80',
                                                borderRadius: '1px 0 0 1px'
                                            }
                                        }}
>
                                        <Typography
                                            variant="h5"
                                            color="white"
                                            fontWeight="bold"
                                            textAlign="center"
                                            sx={{
                                                pt: 0.5,
                                                pb: 0.5,
                                                letterSpacing: '0.5px',
                                                textTransform: 'uppercase',
                                                fontSize: '1.2rem'
                                            }}
                                        >
                                        ความรับผิดชอบต่อหน้าที่
                                    </Typography>
                                    </Box>

                                    <Grid container  >
                                        
                                            {lists.map((list, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Box p={2} border={1} bgcolor="white" borderColor="grey.300" borderRadius={1} display="flex" flexDirection="column" alignItems="top"
                                                    >

                                                        <RatingLabel id={index + 1} label={list.label} hookForm={hookForm} viewonly={viewonly} />

                                                    </Box>

                                                </Grid>




                                            ))}
                                        
                                    </Grid>
                                    </Container>

                                    <Container>
                                    <Box
                                        sx={{
                                            background: '#1976D2',
                                            borderRadius: 1,
                                            boxShadow: 'none',
                                            color: 'white', 
                                            px: 2, // Keep horizontal padding
                                            py: 0, // Remove vertical padding
                                            //mb: 1,
                                            mt: 3,
                                            position: 'relative',
                                            display: 'inline-block',
                                            minWidth: 'fit-content',
                                            height: 'fit-content', // Ensure height fits content exactly
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '50%', // Center the accent bar
                                                transform: 'translateY(-50%)', // Center the accent bar
                                                width: '4px',
                                                height: '100%',
                                                backgroundColor: '#FFCC80',
                                                borderRadius: '1px 0 0 1px'
                                            }
                                        }}
>
                                        <Typography
                                            variant="h5"
                                            color="white"
                                            fontWeight="bold"
                                            textAlign="center"
                                            sx={{
                                                pt: 0.5,
                                                pb: 0.5,
                                                letterSpacing: '0.5px',
                                                textTransform: 'uppercase',
                                                fontSize: '1.2rem'
                                            }}
                                        >
                                        ความรู้ ความสามารถในการปฏิบัติงาน
                                    </Typography>
                                    </Box>

                                    <Grid container spacing={0} >
                                       
                                            {lists2.map((list, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Box p={2} border={1} bgcolor="white" borderColor="grey.300" borderRadius={1} display="flex" flexDirection="column" alignItems="top"
                                                    >

                                                        <RatingLabel id={index + 6} label={list.label} hookForm={hookForm} viewonly={viewonly} />

                                                    </Box>

                                                </Grid>
                                            ))}
                                        
                                    </Grid>
                                    </Container>
                                    <Container>
                                    <Box
                                        sx={{
                                            background: '#1976D2',
                                            borderRadius: 1,
                                            boxShadow: 'none',
                                            color: 'white', 
                                            px: 2, // Keep horizontal padding
                                            py: 0, // Remove vertical padding
                                            //mb: 1,
                                            mt: 3,
                                            position: 'relative',
                                            display: 'inline-block',
                                            minWidth: 'fit-content',
                                            height: 'fit-content', // Ensure height fits content exactly
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '50%', // Center the accent bar
                                                transform: 'translateY(-50%)', // Center the accent bar
                                                width: '4px',
                                                height: '100%',
                                                backgroundColor: '#FFCC80',
                                                borderRadius: '1px 0 0 1px'
                                            }
                                        }}
>
                                        <Typography
                                            variant="h5"
                                            color="white"
                                            fontWeight="bold"
                                            textAlign="center"
                                            sx={{
                                                pt: 0.5,
                                                pb: 0.5,
                                                letterSpacing: '0.5px',
                                                textTransform: 'uppercase',
                                                fontSize: '1.2rem'
                                            }}
                                        >
                                        คุณลักษณะส่วนบุคคล 
                                    </Typography>
                                    </Box>

                                    <Grid container spacing={0} >
                                        
                                            {lists3.map((list, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Box p={2} border={1} bgcolor="white" borderColor="grey.300" borderRadius={1} display="flex" flexDirection="column" alignItems="top"
                                                    >

                                                        <RatingLabel id={index + 11} label={list.label} hookForm={hookForm} viewonly={viewonly} />

                                                    </Box>

                                                </Grid>
                                            ))}
                                        
                                    </Grid>
                                    </Container>

                                    <Container>
                                    <Box
                                        sx={{
                                            background: '#1976D2',
                                            borderRadius: 1,
                                            boxShadow: 'none',
                                            color: 'white', 
                                            px: 2, // Keep horizontal padding
                                            py: 0, // Remove vertical padding
                                            //mb: 1,
                                            mt: 3,
                                            position: 'relative',
                                            display: 'inline-block',
                                            minWidth: 'fit-content',
                                            height: 'fit-content', // Ensure height fits content exactly
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '50%', // Center the accent bar
                                                transform: 'translateY(-50%)', // Center the accent bar
                                                width: '4px',
                                                height: '100%',
                                                backgroundColor: '#FFCC80',
                                                borderRadius: '1px 0 0 1px'
                                            }
                                        }}
>
                                        <Typography
                                            variant="h5"
                                            color="white"
                                            fontWeight="bold"
                                            textAlign="center"
                                            sx={{
                                                pt: 0.5,
                                                pb: 0.5,
                                                letterSpacing: '0.5px',
                                                textTransform: 'uppercase',
                                                fontSize: '1.2rem'
                                            }}
                                        >
                                        ความรู้ความสามารถที่เรียนนำมาประยุกต์ใช้ในการปฏิบัติงาน 
                                    </Typography>
                                    </Box>

                                    <Grid container spacing={0} >
                                        
                                            {lists4.map((list, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Box p={2} border={1} bgcolor="white" borderColor="grey.300" borderRadius={1} display="flex" flexDirection="column" alignItems="top"
                                                    >

                                                        <RatingLabel id={index + 20} label={list.label} hookForm={hookForm} viewonly={viewonly} />

                                                    </Box>

                                                </Grid>
                                            ))}
                                       
                                    </Grid>
                                    </Container>
                                    
                                    <Container>
                                    <Box
                                        sx={{
                                            background: '#1976D2',
                                            borderRadius: 1,
                                            boxShadow: 'none',
                                            color: 'white', 
                                            px: 2, // Keep horizontal padding
                                            py: 0, // Remove vertical padding
                                            //mb: 1,
                                            mt: 3,
                                            position: 'relative',
                                            display: 'inline-block',
                                            minWidth: '100%',
                                            height: 'fit-content', // Ensure height fits content exactly
                                            justifyItems: 'start',
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '50%', // Center the accent bar
                                                transform: 'translateY(-50%)', // Center the accent bar
                                                width: '4px',
                                                height: '100%',
                                                backgroundColor: '#FFCC80',
                                                borderRadius: '1px 0 0 1px'
                                            }
                                        }}
>
                                        <Typography
                                            variant="h5"
                                            color="white"
                                            fontWeight="bold"
                                            textAlign="center"
                                            sx={{
                                                pt: 0.5,
                                                pb: 0.5,
                                                letterSpacing: '0.5px',
                                                textTransform: 'uppercase',
                                                fontSize: '1.2rem'
                                            }}
                                        >
                                            ลักษณะงานที่นิสิตได้รับมอบหมายจากสถานประกอบการ
                                        </Typography>
                                    </Box>
                                    
                                    <Box p={1} bgcolor="white" borderRadius={1} border={1} borderColor="grey.300" justifyItems= 'center'>

                                        <RadioGroup row value={parseInt(list25Value) || ''}
                                            onChange={(e) => setValue('list_25', parseInt(e.target.value))}

                                        >
                                            <FormControlLabel value={1} {...register("list_25")} control={<Radio />} label="โครงการ" disabled={viewonly} />
                                            <FormControlLabel value={2} {...register("list_25")} control={<Radio />} label="งานประจำ" disabled={viewonly} />
                                            <FormControlLabel value={3} {...register("list_25")} control={<Radio />} label="โครงงานและงานประจำ" disabled={viewonly} />

                                        </RadioGroup>
                                    </Box>
                                    </Container>

                                    <Container>
                                    <Box
                                        sx={{
                                            background: '#1976D2',
                                            borderRadius: 1,
                                            boxShadow: 'none',
                                            color: 'white', 
                                            px: 2, // Keep horizontal padding
                                            py: 0, // Remove vertical padding
                                            //mb: 1,
                                            mt: 3,
                                            position: 'relative',
                                            display: 'inline-block',
                                            minWidth: 'fit-content',
                                            height: 'fit-content', // Ensure height fits content exactly
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: '50%', // Center the accent bar
                                                transform: 'translateY(-50%)', // Center the accent bar
                                                width: '4px',
                                                height: '100%',
                                                backgroundColor: '#FFCC80',
                                                borderRadius: '1px 0 0 1px'
                                            }
                                        }}
>
                                        <Typography
                                            variant="h5"
                                            color="white"
                                            fontWeight="bold"
                                                textAlign="start"
                                                sx={{
                                                    pt: 0.5,
                                                    pb: 0.5,
                                                    letterSpacing: '0.5px',
                                                    textTransform: 'uppercase',
                                                    fontSize: '1.2rem'
                                                }}
                                            >
                                                หากนิสิตได้รับมอบหมายให้ทำโครงงาน ท่านคิดว่าโอกาสต่อยอดโครงงานของนิสิตเป็นงานวิจัยหรือ บริการวิชาชีพมีความเป็นไปได้มากน้อยเพียงใด                                         </Typography>
                                        </Box>

                                        <Box p={1} bgcolor="white" borderRadius={1} border={1} borderColor="grey.300" justifyItems="center">

                                            <RadioGroup row value={parseInt(list26Value) || ''}
                                                onChange={(e) => setValue('list_26', parseInt(e.target.value))}

                                            >
                                                <FormControlLabel value={1} {...register("list_26")} control={<Radio />} label="น้อยที่สุด" disabled={viewonly} />
                                                <FormControlLabel value={2} {...register("list_26")} control={<Radio />} label="น้อย" disabled={viewonly} />
                                                <FormControlLabel value={3} {...register("list_26")} control={<Radio />} label="ปานกลาง" disabled={viewonly} />
                                                <FormControlLabel value={4} {...register("list_26")} control={<Radio />} label="มาก" disabled={viewonly} />
                                                <FormControlLabel value={5} {...register("list_26")} control={<Radio />} label="มากที่สุด" disabled={viewonly} />

                                            </RadioGroup>
                                        </Box>



                                    </Container>


            </Box>
  
  
            <Box mb={3} p={2} border={1} bgcolor="#E3F2FD" borderColor="grey.300" borderRadius={1}>
            <Box display="flex" alignItems="center" gap={2}>
                                        <Typography variant="h5" color="primary" fontWeight={'bold'}
                                            sx={{ textDecoration: 'underline' }}>
                                            ส่วนที่ 2
                                        </Typography>
                                        {!isMobile ? (
                                            <Typography variant="h6" color="black">
                                               ข้อเสนอแนะอื่น ๆ เกี่ยวกับการปฎิบัติงานของนิสิตสหกิจศึกษา
                                            </Typography>
                                        ) : (
                                            <Typography variant="h6" color="black">
                                                ข้อเสนอแนะอื่น ๆ 
                                            </Typography>
                                        )}
                                    </Box>

             
                                    <Box border={1} bgcolor="white" borderColor="grey.300" borderRadius={1} p={2} mt={2}>
                                        <TextField
                                            multiline
                                            minRows={5}
                                            fullWidth
                                            disabled={viewonly}
                                            {...register("comment")}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="standard"
                                            sx={{
                                                '& .MuiInputBase-input': {
                                                    px: 1, // Add horizontal padding
                                                    py: 1  // Add vertical padding
                                                }
                                            }}
                                        />
                                    </Box>
                
             
            </Box>
  
            <Box mb={3} p={2} border={1} bgcolor= "#F0F8FF" borderColor="grey.300" borderRadius={2}>
              <Typography variant="h6" color="primary" gutterBottom fontWeight="bold" >
                ผู้ประเมิน/อาจารย์นิเทศ
              </Typography>
              <Grid container spacing={3} >
                <Grid item xs={12} md={6}>
                  <Box  bgcolor="white" borderColor="grey.300" borderRadius={2} mt={1}>
                  <TextField
                    label="ชื่อผู้ประเมิน"
                    fullWidth
                    
                    {...register("evaluatorName")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    disabled={viewonly}
                    
                  />
                  </Box>
                </Grid>
  
                <Grid item xs={12} md={6}>
                  <Box  bgcolor="white" borderColor="grey.300" borderRadius={2} mt={1}>
                  <TextField
                    label="วัน/เวลาที่ประเมิน"
                    fullWidth
                    {...register("timestamp")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    disabled
                  />
                  </Box>
                </Grid>
              </Grid>
            </Box>
  
            <Grid item xs={12} textAlign="center">
              {profile.m_role === "staff" && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                disabled ={viewonly}
              >
                ส่งผลประเมิน
              </Button>
              )}
            </Grid>
          </form>
        </Paper>
      </Container>)}
      </ThemeProvider>
    );
  };
  
  export default AssessmentVisitCoop;
  